'use client'

import { useEffect } from 'react'
import useAgentListContext from '../context'

export default function AgentSearchH1Content({
  text,
  totals
}) {

  const { setTotals } = useAgentListContext()
  useEffect(() => {
    setTotals(totals)
  }, [totals, setTotals])

  return (
    <div className='pt-20 flex items-center justify-center'>
      <h1 className='text-font text-2xl font-extralight text-center' dangerouslySetInnerHTML={{ __html: text || '' }}></h1>
    </div>
  )
}